import React, { useState } from 'react'

const subjectOptions = [
  { label: 'English', value: 'english', dataKey: 'results' },
  { label: 'Mathematics', value: 'math', dataKey: 'results2' },
  { label: 'Reading', value: 'reading', dataKey: 'results3' },
  { label: 'Science', value: 'science', dataKey: 'results4' },
]

const subjectColors = {
  english: '#4E57EF', // Blue
  math: '#DE3C7D', // Pink
  reading: '#F36F4A', // Orange
  science: '#3BBC4C', // Green
}

const ProgressBar = ({ percent, color }) => (
  <div className="w-full h-2 bg-[#E5E7EB] rounded overflow-hidden flex items-center mx-4">
    <div
      className="h-2 rounded"
      style={{
        width: `${percent}%`,
        background: color,
        transition: 'width 0.4s',
      }}
    />
  </div>
)

const FIXED_LABEL_WIDTH = '300px' // Reduced width for first column
const PROGRESS_BAR_WIDTH = '220px'
const LAST_COLUMN_WIDTH = '130px' // Increased width for last column

const StrengthsWeaknesses = ({
  results,
  results2,
  results3,
  results4,
  testType,
}) => {
  const [selectedSubject, setSelectedSubject] = useState('english')
  const dataMap = {
    english: results,
    math: results2,
    reading: results3,
    science: results4,
  }
  const data = dataMap[selectedSubject] || []
  const barColor = subjectColors[selectedSubject] || '#4E57EF'

  const dropdownOptions =
    testType === 'SAT'
      ? [
          { label: 'English', value: 'english' },
          { label: 'Math', value: 'math' },
        ]
      : [
          { label: 'English', value: 'english' },
          { label: 'Math', value: 'math' },
          { label: 'Reading', value: 'reading' },
          { label: 'Science', value: 'science' },
        ]

  return (
    <div className="bg-white rounded-xl border border-[#F0F0F0] p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="text-xl font-bold text-[#222]">
          {subjectOptions.find((opt) => opt.value === selectedSubject)?.label}{' '}
          Overview
        </div>
        <select
          className="border rounded px-3 py-1"
          value={selectedSubject}
          onChange={(e) => setSelectedSubject(e.target.value)}
        >
          {dropdownOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        {data && data.length > 0 ? (
          data.map((topic, idx) => {
            const topicPercent = topic.topic_count
              ? ((topic.correct_count / topic.topic_count) * 100).toFixed(0)
              : 0
            return (
              <div
                key={topic._id || idx}
                className="mb-6 rounded-xl border border-[#F0F0F0] bg-[#FAFAFA]"
                style={{ overflow: 'hidden' }}
              >
                <table className="w-full table-fixed">
                  <colgroup>
                    <col style={{ width: FIXED_LABEL_WIDTH }} />
                    <col style={{ width: PROGRESS_BAR_WIDTH }} />
                    <col style={{ width: '90px' }} />
                    <col style={{ width: LAST_COLUMN_WIDTH }} />
                  </colgroup>
                  <tbody>
                    {/* Topic summary row with progress bar */}
                    <tr className="bg-[#F3F3F3] font-bold text-[#222] text-base">
                      <td className="py-4 pl-6 pr-2 align-middle">
                        {topic.topic_title} ({topic.topic_code})
                      </td>
                      <td className="py-4 px-2 align-middle">
                        <ProgressBar percent={topicPercent} color={barColor} />
                      </td>
                      <td
                        className="py-4 px-2 font-bold text-right whitespace-nowrap align-middle"
                        style={{ color: barColor }}
                      >
                        {topicPercent}%
                      </td>
                      <td className="py-4 pr-8 pl-2 text-[#222] text-right whitespace-nowrap align-middle">
                        {topic.correct_count} of {topic.topic_count}
                      </td>
                    </tr>
                    {/* Subtopic rows */}
                    {topic.subtopics &&
                      topic.subtopics.length > 0 &&
                      topic.subtopics.map((sub, sidx) => {
                        const percent = sub.count
                          ? ((sub.status_count / sub.count) * 100).toFixed(0)
                          : 0
                        return (
                          <tr
                            key={sub._id || sidx}
                            className={
                              sidx !== topic.subtopics.length - 1
                                ? 'border-b border-[#F0F0F0]'
                                : ''
                            }
                          >
                            <td className="py-3 pl-10 pr-2 text-[#222] text-sm align-middle">
                              {sub.stopic_title} ({sub.stopic_code})
                            </td>
                            <td className="py-3 px-2 align-middle">
                              <ProgressBar percent={percent} color={barColor} />
                            </td>
                            <td
                              className="py-3 px-2 font-bold text-right whitespace-nowrap align-middle"
                              style={{ color: barColor }}
                            >
                              {percent}%
                            </td>
                            <td className="py-3 pr-8 pl-2 text-[#222] text-right whitespace-nowrap align-middle">
                              {sub.status_count} of {sub.count}
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            )
          })
        ) : (
          <div className="text-center text-[#888] py-8">
            No data available for this subject.
          </div>
        )}
      </div>
    </div>
  )
}

export default StrengthsWeaknesses
